import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from "react-router-dom"
import React, { useRef, useState, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import '../../components/css/GalleryImgFilter.css'
import data from './RumahData'

function RumahFilter() {
    const ref = useRef(null);

    //const listCategoryItem = ['konstruksi', 'renovasi'];
    //const [filter, setFilter] = useState('');

    const [stringValue, setTextValue] = useState('')
    const [stringFilter, setUpdated] = useState(stringValue)
    const [stringButtonValue, setClearResultFilter] = useState(stringFilter)

    const [stringNotFound, setSearchNotFound] = useState(stringValue)

    const handleChange = (event) => {
        setTextValue(event.target.value)
        setClearResultFilter(event.target.value)
    };

    const handleClick = () => {
        // message" stores input field value
        setUpdated(stringValue)
        setTextValue('')
        /** set focused input 
        ref.current.focus();
        */
    };

    const requestDisableInputFilter = () => {
        this.setState({ disabled: !this.state.disabled })
    }

    const clearResultFilter = () => {
        setTextValue('')
        setUpdated('')
        setClearResultFilter('')
    }

    const onSearchNotFound = (not_found) => {
        setSearchNotFound(not_found)
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleClick()
        }
    }

    /** navigation from button click blog list item */
    const navigate = useNavigate();
    const navigateTo = (path_to) => {
        navigate(path_to);
    };

    /**
     * const navigate = useNavigate();
    const navigateTo = (path_to, id) => {
        {
            data
                .filter((val) => {
                    if (stringFilter == val.setNavigate) {
                        navigate(path_to);
                    } else if (stringFilter == "") {
                        // method to jump to the desired element by using the element's id
                        const releventDiv = document.getElementById(id);
                        // behavior: "smooth" parameter for smooth movement
                        releventDiv.scrollIntoView({behavior: "smooth"});
                    }
                })
        }
        
    };
    */

    useEffect(() => {

    });

    /* findviewbyid element */
    /*
    var e = document.getElementById("ids");
    var value = e.value;
    var text = e.options[e.selectedIndex].text;
    */

    /** onClick={whatsAppBussines(`https://wa.me/${phonenumber}?text=${tamplateTextMessage}`)} */

    return (
        <div className="m-filter-section">
            <div className="m-filter-container">

                <div className="m-filter-text-input-container">

                    <div className="m-filter-text-input-top-container">
                        <div className="m-filter-text-input-row">
                            <input
                                className="m-filter-input"
                                ref={ref}
                                id="filter"
                                name="filter"
                                type="text"
                                autocomplete="off"
                                placeholder="Cari dan temukan di ini - Kata kunci"
                                value={stringValue}
                                onChange={handleChange}
                                onClick={requestDisableInputFilter}
                                onKeyDown={handleKeyDown} />

                            <button className="m-filter-button" onClick={handleClick}><img src={require('../../../../assets/icon/icon-search-24px.png')} className="m-filter-buttonfa-button-icon" />Cari</button>
                        </div>

                        <div className="m-filter-text-input-row">

                            <div className="m-filter-clear-button-container">

                                <button className="m-filter-button-clear-filter" onClick={clearResultFilter}><img src={require('../../../../assets/icon/icon-delete-trash-24px.png')} className="m-filter-buttonfa-button-icon" />Hapus pencarian</button>

                                <input
                                    className="m-filter-input-result"
                                    ref={ref}
                                    id="filter"
                                    name="filter"
                                    type="text"
                                    autocomplete="off"
                                    placeholder=""
                                    value={stringFilter}
                                    onChange={handleChange} />
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <div className="m-filter-grid" id="ids-filter-grid">
                        {
                            data
                                .filter((val) => {
                                    if (stringFilter == "") {
                                        return val;
                                    } else if (
                                        val.setTagInfo.toLowerCase().includes(stringFilter.toLowerCase()) ||
                                        val.setTitle.toLowerCase().includes(stringFilter.toLowerCase()) ||
                                        val.setDescription.toLocaleLowerCase().includes(stringFilter.toLowerCase()) ||
                                        val.setCompletedProject.toLocaleLowerCase().includes(stringFilter.toLowerCase())) {
                                        return val;
                                    }
                                })

                                .map((val) => {

                                     // Menggunakan id proyek untuk mengambil alt text yang sesuai
                                    const altText = `Desain rumah dengan portofolio proyek rumah | ${val.setTitle} Lokasi ${val.setDescription}`;

                                    return (
                                        <div className="m-filter-row ">
                                            <div className="m-filter-card" key={val.id}>
                                                <div className="m-filter-card-top-container">
                                                    <img className="m-filter-row-image" src={val.setImage} loading="lazy" alt={altText} />
                                                </div>

                                                <div className="m-filter-card-bottom-container">
                                                    <a className="m-filter-tag-text">{val.setTagInfo}</a>
                                                    <a className="m-filter-title-text"><b>{val.setTitle}</b></a>
                                                    <a className="m-filter-description-text" alt={val.setDescription}>{val.setDescription}</a>
                                                    <button className="m-filter-button-read-more" onClick={() => navigateTo(val.setNavigate)}>{val.setCompletedProject}</button>

                                                    {/**<button className="m-filter-button-read-more" onClick={() => navigateTo(val.setNavigate)}>{val.setCompletedProject}</button> */}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                        }
                    </div>
                </div>
            </div>
        </div >
    )
}

export default RumahFilter